module.exports = __webpack_public_path__ + "static/media/bolt.2c4161e6.svg";